const padDatePart = (value) => String(value).padStart(2, '0');

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const DISPLAY_DATE_PATTERN = /^(\d{2})[/-](\d{2})[/-](\d{4})$/;
const LOCAL_DATE_TIME_PATTERN = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/;
const TIMEZONE_PATTERN = /(?:Z|[+-]\d{2}:?\d{2})$/i;
const EXCEL_SERIAL_DATE_MIN = 25569;
const EXCEL_SERIAL_DATE_MAX = 60000;

const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  if (typeof value === 'number') {
    if (value > EXCEL_SERIAL_DATE_MIN && value < EXCEL_SERIAL_DATE_MAX) {
      const excelDate = new Date(Date.UTC(1899, 11, 30) + Math.floor(value) * 86400000);
      return new Date(excelDate.getUTCFullYear(), excelDate.getUTCMonth(), excelDate.getUTCDate());
    }
    const numericDate = new Date(value);
    return Number.isNaN(numericDate.getTime()) ? null : numericDate;
  }

  const text = String(value).trim();
  const dateOnlyMatch = text.match(DATE_ONLY_PATTERN);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const displayDateMatch = text.match(DISPLAY_DATE_PATTERN);
  if (displayDateMatch) {
    const [, first, second, year] = displayDateMatch;
    const month = Number(first) > 12 ? second : first;
    const day = Number(first) > 12 ? first : second;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const localDateTimeMatch = text.match(LOCAL_DATE_TIME_PATTERN);
  if (localDateTimeMatch && !TIMEZONE_PATTERN.test(text)) {
    const [, year, month, day, hour, minute, second = '0'] = localDateTimeMatch;
    return new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second));
  }

  const parsedDate = new Date(text);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const formatDate = (value, fallback = '-') => {
  const date = toDate(value);
  if (!date) return fallback;

  return [
    padDatePart(date.getMonth() + 1),
    padDatePart(date.getDate()),
    date.getFullYear()
  ].join('/');
};

export const formatDateTime = (value, fallback = '-') => {
  const date = toDate(value);
  if (!date) return fallback;

  return `${formatDate(date, fallback)} ${padDatePart(date.getHours())}:${padDatePart(date.getMinutes())}`;
};
